<template lang="pug">
    ib-modal(
        ref="modal",
        :width="width",
        :height="height",
        role="alertdialog",
        describedby="_alert-msg")
        article(id="_alert-msg", dir="auto", v-markdown._blank="msg")
        template(slot="buttons")
            div(v-if="dismissable", class="_mdismiss")
                ib-checkbox(v-model="dismiss", class="fs7") {{$locale.data.dismissable}}
            ib-button-group
                ib-button(:tone="tone", @click="onOK", bind="Escape", autofocus) {{verb || $locale.data.OK}}
</template>

<script>
    /**
     * A modal that displays a Markdown formatted message, with a single dismiss button.
     */
    export default {
        name: 'alert',

        props: {
            /**
             * The message displayed in the modal.
             */
            msg: {
                type: String,
                required: true
            },
            /**
             * Width in any CSS units.
             */
            width: String,
            /**
             * Height in any CSS units.
             */
            height: String,
            /**
             * Semantic color class applied to button.
             */
            tone: {
                type: String,
                default: 'accent'
            },
            /**
             * An alternative label for the dismiss button.
             */
            verb: String,
            /**
             * A function called on dismissal.
             */
            action: Function,
            /**
             * If `true`, display a "Do not show this message again" checkbox and pass its value
             * as an option to the `action` function.
             */
            dismissable: Boolean
        },

        data() {
            return {
                dismiss: false
            };
        },

        methods: {
            open() {
                this.dismiss = false;
                this.$refs.modal.open();
            },

            onOK() {
                this.$refs.modal.close();
                if (this.action) {
                    this.$nextTick(() => {
                        this.action({
                            dismiss: this.dismiss
                        });
                    });
                }
            }
        }
    }
</script>

<style lang="less">
    @import "../less/globals.less";

    #_alert-msg,
    #_confirm-msg {
        flex: 1 1 auto;

        > :first-child {
            margin-top: 0;
        }
        > :last-child {
            margin-bottom: 0;
        }

        pre {
            .font-size(@fs7);
        }
        table {
            width: 100%;
            border-top: 1px solid @border-default;
        }
        td {
            .font-size(@fs7);
            border-bottom: 1px solid @border-default;
            &:first-child {
                color: fade(@fg, 50%);
            }
        }
    }
</style>
